// Maps getUserMedia failures to a message the user can act on.
export const micErrorMessage = (error) => {
    if (error?.name === "NotFoundError" || error?.name === "DevicesNotFoundError") return "No microphone found. Please connect a microphone and try again.";
    if (error?.name === "NotAllowedError" || error?.name === "PermissionDeniedError") return "Microphone access is blocked. Please allow it in your browser settings.";
    if (error?.name === "NotReadableError") return "Your microphone is being used by another app. Close it and try again.";
    return "Could not start recording. Please check your microphone.";
};
